import { useCallback } from "react";
import { assignRef } from "../utils/assignRef";

export function useMergeRefs<T>(...ref: React.ForwardedRef<T>[]) {
  return useCallback(
    (value: T) => {
      ref.forEach((ref) => assignRef(ref, value));
    },
    [ref]
  );
}
